// ***************************************************************************************
// onShowSpeakerMenu()
// affiche le menu pour changer le speaker du mot
// ***************************************************************************************
export function onShowSpeakerMenu(x, y, speakerArea) {
  if (this.readonly) {
    return;
  }

  if (this.speakerMenuRef && this.speakerMenuRef.current) {
    this.setState({
      speakerMenu: {
        display: true,
        speakerArea,
      },
    });
    this.speakerMenuRef.current.openMenu(
      x,
      y,
      speakerArea.speakerId,
      speakerArea.wordIndex
    );
  }
}

export function onCloseSpeakerMenu(speakerId) {
  if (this.state.speakerMenu.display) {
    this.state.speakerMenu.speakerArea.callbackClose(
      speakerId
    );

    this.setState({
      speakerMenu: {
        display: false,
        speakerArea: null,
      },
    });

    if (this.speakerMenuRef && this.speakerMenuRef.current) {
      this.speakerMenuRef.current.closeMenu();
    }

    this.onRefreshCanvas();
  }
}

// ***************************************************************************************
// onSelectSpeaker()
// Appelée quand l'utilisateur sélectionne un speaker du menu
// ***************************************************************************************
export function onSelectSpeaker(speakerId, wordIndex) {
  if (!this.script || !this.script[wordIndex]) {
    return;
  }

  // On historise l'action pour pouvoir l'annuler
  this.addNewActionForUndo('changeSpeaker', wordIndex, 0, 0);

  const word = this.script[wordIndex];

  const words = this.getWordsByIndexLine(word.indexLine);

  // On met à jour le speaker des mots de la ligne
  words.forEach((w) => {
    w.speakerId = speakerId;
  });

  this.onCloseSpeakerMenu(speakerId);

  this.onChange(word.startTime, wordIndex);
}
